/**
 * @description https://developer.mozilla.org/en-US/docs/Web/API/PushSubscription
 */
class WebNotificationHelper {
  static hasPermission() {
    return Notification.permission === 'granted'
  }

  // Eventually we should ask for permission only during user gesture
  // https://developer.mozilla.org/en-US/docs/Web/API/Notifications_API/Using_the_Notifications_API
  static canAskPermission() {
    return 'Notification' in window && Notification.permission === 'default'
  }

  static isSupported() {
    return 'Notification' in window
  }

  static async getPushSubscription() {
    const registration = await navigator.serviceWorker.ready
    return await registration.pushManager.getSubscription()
  }

  static async getPushSubscriptionObject() {
    const subscription = await this.getPushSubscription()
    // subscription can be null did not allow notifications or after switching permissions on for the first time
    if (!subscription) return null

    return {
      endpoint: subscription.endpoint,
      encoding: PushManager.supportedContentEncodings,
      p256dh: btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('p256dh')))),
      auth: btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('auth')))),
    }
  }

  static requestPushPermission = async () => {
    if (!this.isSupported()) {
      console.error('Notification not supported')
      return 'not_supported'
    }

    try {
      const permission = await window.Notification.requestPermission()
      if (permission !== 'granted') console.error('Permission not granted for Notification')
      return permission
    } catch (error) {
      // Safari doesn't return a promise for requestPermissions and it
      // throws a TypeError. It takes a callback as the first argument
      // instead.
      if (error instanceof TypeError) {
        return await new Promise((resolve, reject) => {
          try {
            Notification.requestPermission(() => resolve('granted'))
          } catch (error) {
            console.error('Error requesting notification permission:', error)
            reject(error)
          }
        })
      } else {
        throw error
      }
    }
  }

  static async subscribePush() {
    const registration = await navigator.serviceWorker.ready
    return await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: process.env.REACT_APP_VAPID_PUBLIC_KEY,
    })
  }

  static async unsubscribePush() {
    const subscription = await this.getPushSubscription()
    if (!subscription) {
      console.warn('No push subscription found to unsubscribe')
      return false
    }
    return await subscription.unsubscribe()
  }

  // Legacy code for triggering notifications, kept for reference
  // static async triggerNotification(title, body, data, callback) {
  //   if (typeof Notification === 'undefined') return
  //
  //   if (!this.hasPermission()) await this.requestPermission()
  //
  //   if (isMobile) this.handleSwNotification(title, body, data)
  //   else this.handleDesktopNotification(title, body, callback)
  // }

  // static async handleSwNotification(title, body, data = {}) {
  //   const registration = await navigator.serviceWorker.ready
  //   registration.showNotification(title, { icon: '/images/icons/sc-logo.png', data, body })
  // }

  // static handleDesktopNotification(title, body, callback) {
  //   const notification = new Notification(title, { icon: '/images/icons/sc-logo.png', body })
  //   notification.onclick = function () {
  //     window.focus()
  //     this.close()
  //     if (callback) callback()
  //   }
  //   // setTimeout(notification.close.bind(notification), 5000);
  // }
}

export default WebNotificationHelper
